import { inject, Injectable } from '@angular/core';
import { LoginModel } from '../../models/login/login.model';
import { environment } from '../../../../environments/environment';

import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { SessionStorageService } from '../session-storage/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserAuthenticationService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  // Login API
  async authenticateCredentials(login: LoginModel) {
    const API_URL: string = environment.baseUrl + environment.apis.login;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: login
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  // Login API
  async authenticateCredentialsMfa(login: LoginModel) {
    const API_URL: string = environment.baseUrl + environment.apis.loginMfa;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: login
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  // Logout API
  async userLogout() {
    const API_URL: string = environment.baseUrl + environment.apis.logout;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        "username": this.sessionStorageService.getCurrentUserEmail()
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

}
